import { render, staticRenderFns } from "./globalButton.vue?vue&type=template&id=439585e1&scoped=true&"
import script from "./globalButton.vue?vue&type=script&lang=js&"
export * from "./globalButton.vue?vue&type=script&lang=js&"
import style0 from "./globalButton.vue?vue&type=style&index=0&id=439585e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439585e1",
  null
  
)

export default component.exports